import script from "./svg-circle-dasharray.vue?vue&type=script&lang=ts&setup=true"
export * from "./svg-circle-dasharray.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__